import React from 'react';

const StatsTimeCircle = React.forwardRef(function StatsTimeCircle({ dash }, ref) {
  return (
    <div className={'stats__time-circle'}>
      <svg width={'56'} height={'56'} viewBox={'0 0 56 56'} preserveAspectRatio={'xMinYMin meet'}>
        <path
          stroke-dasharray={dash}
          stroke-dashoffset={'100'}
          d={
            'M28 14C31.713 14 35.274 15.475 37.8995 18.1005C40.525 20.726 42 24.287 42 28C42 31.713 40.525 35.274 37.8995 37.8995C35.274 40.525 31.713 42 28 42C24.287 42 20.726 40.525 18.1005 37.8995C15.475 35.274 14 31.713 14 28C14 24.287 15.475 20.726 18.1005 18.1005C20.726 15.475 24.287 14 28 14Z'
          }
          stroke={'#FF232F'}
          stroke-width={'28'}
        />
      </svg>
    </div>
  );
});
export default StatsTimeCircle;
StatsTimeCircle.propTypes = {};
